import React, { useState, useEffect, useRef, useContext } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import Footer from "../Footer";
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import { useNavigate } from "react-router-dom";
import tmdbApi from "../../api/tmdbApi";
import SessionPopup from "../SessionPopup";
import Modal from 'react-bootstrap/Modal';
// import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
// import StarIcon from '@mui/icons-material/Star';
// import LockIcon from '@mui/icons-material/Lock';

import { ToastContainer, toast } from 'react-toastify';

let { lambda, appname } = window.app;

const ML = ({ type, moduleType = null }) => {
//kfkfk
    const [data, setData] = useState([]);
    const [tagsPrepared, setTagsPrepared] = useState(false);
    const [tagCarousels, setTagCarousels] = useState([]);
    const [activeVideo, setActiveVideo] = useState(null);
    const [inputQuery, setInputQuery] = useState('');
    const [query, setQuery] = useState('');
    const [searchField, setSearchField] = useState('title');
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const { GetTimeActivity, isLoading, setIsLoading } = useContext(contentContext);
    const [selectedTag, setSelectedTag] = useState(-1);
    const [razorpayKey, setRazorpayKey] = useState(null);
    const [errorMsg, setErrorMsg] = useState(false);
    const [options, setOptions] = useState([]); // dropdown list (label/value)
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [showAccessCodePopup, setShowAccessCodePopup] = useState(false);
    const [showBuyAlert, setShowBuyAlert] = useState(false);
    const [buyModuleItem, setBuyModuleItem] = useState(null);
    const navigate = useNavigate();
    const itemsPerPage = 12;
    const token = localStorage.getItem("token");
    const backTpPrev = () => {
        navigate(-1); // go back
    }

    const [activeReadMoreModal, setActiveReadMoreModal] = useState(false);
    const [modalContent, setModalContent] = useState("");


    // --- Access Code Popup States ---
    const [accessCode, setAccessCode] = useState("");
    const [errorDisplay, setErrorDisplay] = useState(false);
    const [errorData, setErrorData] = useState({ accessCode: "" });
    const [loadingAccess, setLoadingAccess] = useState(false);
    const [selectedModule, setSelectedModule] = useState(null);

    // --- Handle Input Change ---
    const handleAccessCodeChange = (e) => {
        setAccessCode(e.target.value);
        if (errorDisplay) {
            setErrorDisplay(false);
            setErrorData({ accessCode: "" });
        }
    };

    // --- Verify Access Code via API ---
    const handleAccessCodeSubmit = (e) => {
        e.preventDefault();

        if (!accessCode.trim()) {
            setErrorDisplay(true);
            setErrorData({ accessCode: "Access code is required" });
            return;
        }

        if (!selectedModule) {
            setErrorDisplay(true);
            setErrorData({ accessCode: "No module selected" });
            return;
        }

        setLoadingAccess(true);

        const moduleId = selectedModule?.moduleid;

        const userId = localStorage.getItem("userId")
        axios({
            method: "POST",
            url: `${lambda}/accessCode?appname=${appname}&moduleid=${moduleId}&userid=${userId}`,
            data: { accessCode },
            headers: {
                "Content-Type": "application/json",
                Authorization: token ? `Bearer ${token}` : "",
            },
        })
            .then((response) => {
                setLoadingAccess(false);

                const { statusCode, result } = response?.data || {};

                if (statusCode === 200 && result === "Sucess") {
                    // ✅ Valid access code
                    handleClosePopup();
                    localStorage.removeItem("usermodule");
                    localStorage.setItem("module", "module");

                    if (!token) {
                        navigate("/login");
                        localStorage.setItem("moduleid", selectedModule);
                        return;
                    }
                    if (selectedModule?.subscribed === true) {

                        navigate(`/timed-instructions/${selectedModule?.moduleid}`, {
                            state: { moduleType: moduleType, moduleid: selectedModule?.moduleid }
                        });
                        // navigate(`/moduleslibrary/${item?.moduleid}`);
                        return;
                    }
                    if (
                        selectedModule?.cost !== 0 &&
                        selectedModule?.cost !== "0"
                    ) {
                        setBuyModuleItem(selectedModule);
                        setShowBuyAlert(true);
                        localStorage.setItem("moduleid", selectedModule?.moduleid);
                    } else {

                        navigate(`/timed-instructions/${selectedModule?.moduleid}`, {
                            state: { moduleType: moduleType, moduleid: selectedModule?.moduleid }
                        });

                        // navigate(`/timedmodule/${selectedModule?.moduleid}`, {
                        //     state: { moduleType: moduleType }
                        // });
                    }
                } else if (statusCode === 200 && result === "accessCode is incorrect") {
                    // ❌ Invalid access code
                    setErrorDisplay(true);
                    setErrorData({ accessCode: "Invalid access code" });
                } else {
                    // ❌ Unexpected response
                    setErrorDisplay(true);
                    setErrorData({
                        accessCode: "Unexpected server response. Please try again.",
                    });
                }
            })
            .catch((error) => {
                setLoadingAccess(false);
                setErrorDisplay(true);
                setErrorData({
                    accessCode: "Something went wrong. Please try again.",
                });
                console.error("Access code verification failed:", error);
            });

    };

    useEffect(() => {
        // if (!localStorage.getItem("token")) {
        //     navigate("/");
        // }
        const fetchConfigAndTags = async () => {
            const response = await tmdbApi.configData();
            if (response?.result && response?.result.length > 0) {
                setRazorpayKey(response?.result[0]?.RAZORPAY_KEY_ID);
            }
            await getTagAPI();
            window.scrollTo(0, 0);
        };
        fetchConfigAndTags();
        getTags();
        fetchLibraryData(query, currentPage);
    }, [type, moduleType]);


    const getTagAPI = async () => {
        let result = await tmdbApi.librarytaginfo(type);
        if (result?.result === "Invalid token or Expired") {
            // handle invalid token if needed
            setIsLoading(false)
            setShowSessionPopupup(true)
        } else if (result?.result?.length > 0) {
            setTagCarousels(result?.result?.sort());
            setTagsPrepared(true);
        } else {
            setTagCarousels([]);
            setTagsPrepared(false);
        }
    };


    useEffect(() => {
        fetchLibraryData(query, currentPage);
    }, [query, currentPage]);

    const getTags = (e) => {
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        const type = moduleType === "timedmodule" ? "timedTag" : "moduleTag"
        // if (moduleType === "timedmodule") {
        //     type = "timedTag"
        // }else{
        //     type = "moduleTag"
        // }
        axios({
            method: 'GET',
            url: lambda + '/tagInfo?appname=' + appname + '&type=' + type,

            // + '&token=' + token,
        })
            .then(function (response) {
                // console.log("response tagsssssssssssss", response?.data?.result);

                const list = response?.data?.result?.map((tag) => tag.name

                );

                console.log('list', list)
                setOptions(list);


            });
    }
    // console.log('list', options)
    const clearSearch = () => {
        localStorage.removeItem("moduleid")
        setInputQuery('');
        setQuery('');
        setSelectedTag(-1);
        setCurrentPage(1);
        fetchLibraryData('', 1);
    };


    const submitData = () => {
        if (inputQuery.trim().length === 0 || inputQuery === "") {
            toast.error("Search field cannot be empty.");

            return;
        }
        setSelectedTag(-1);
        setCurrentPage(1);
        setQuery(inputQuery);
    };

    useEffect(() => {
        const Id = localStorage.getItem('moduleid');
        // console.log("Module ID from localStorage:", Id);

        // Only run if data is not empty and Id exists
        if (Id && data.length > 0) {
            const filteredData = data.find((item) => item?.moduleid === Id);
            console.log("Filtered data:", filteredData);

            if (filteredData) {
                setBuyModuleItem(filteredData);
                setShowBuyAlert(true);
            }
        }
    }, [data]);


    const fetchLibraryData = (searchQuery = '', page = 1) => {
        setIsLoading(true);
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        let params = {
            appname,
            assetcount: itemsPerPage,
            pageNumber: page,
            search: searchQuery,
            token: token,
            pageName: 'ACTIVE',
            // type: moduleType !== null ? "Timed Module" : "Learning Module",
            type: moduleType ==="mcqmodule" ? "MCQ Module" : moduleType ==="timedmodule" ? "Timed Module" : "Learning Module",
            moduleType: !type ? "user" : 'all',
            userid: userid,
            projection: 'learninghub',


        }

        // if (moduleType !== "timedmodule") {
        //     params.submodule = "SELF";
        // }
        

       if (moduleType !== "timedmodule" && moduleType !== "mcqmodule") {
            params.submodule = "SELF";
        }
         if (moduleType === "timedmodule"|| moduleType === "mcqmodule") {
            params.availableModules = true;
        }
      
        
        // if (moduleType === "mcqmodule") {
        //     params.submodule = "MCQ";
        // }

        axios
            .get(`${lambda}/moduleInfo`, {
                params: params
            })
            .then((response) => {
                const result = response?.data?.result;
                if (result === "Invalid token or Expired") {
                    // handle invalid token if needed
                    setIsLoading(false)

                    setShowSessionPopupup(true)
                    return;
                }
                // if (result?.data && Array.isArray(result.data)) {
                //     setData(result.data);

                //     let totalPagesTmp = Math.ceil(result.totalCount / itemsPerPage);

                //     if (searchQuery) {
                //         totalPagesTmp = Math.ceil(result.data.length / itemsPerPage);
                //     }
                //     setTotalPages(totalPagesTmp);

                // } else {
                //     setData([]);
                //     setTotalPages(0);
                // }
                console.log("API Response:", result?.data);

                setData(result?.data || []);
                setTotalPages(Math.ceil(result?.totalCount / itemsPerPage) || 0);
                setIsLoading(false)
            })
            .catch((err) => console.error("API error:", err))
            .finally(() => setLoading(false));
    };
    // let tags = [];
    // const prepareTags = (videoData) => {
    //     videoData.forEach(item => {
    //         if (Array.isArray(item.tags)) {
    //             tags = tags.concat(item.tags);
    //         }
    //     });
    //     const latest = [...new Set(tags)];
    //     setTagCarousels(latest);
    // };

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 1 ? match[7] : null;
    };
    const [img, setImg] = useState(null)
    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const TagCarousel = () => {
        const carouselRef = useRef(null);
        const step = 100;

        const handleNext = () => {
            if (carouselRef.current) {
                carouselRef.current.scrollBy({ left: step, behavior: 'smooth' });
            }
        };

        const handlePrev = () => {
            if (carouselRef.current) {
                carouselRef.current.scrollBy({ left: -step, behavior: 'smooth' });
            }
        };

        return (
            <div className="tag-carousel-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                <button className="tag-carousel-btn" onClick={handlePrev}>&#8249;</button>
                <div
                    className="tag-carousel"
                    style={{
                        overflowX: 'auto',
                        scrollBehavior: 'smooth',
                        display: 'flex',
                        flexWrap: 'nowrap',
                        gap: '10px',
                        padding: '10px 0',
                        flex: 1
                    }}
                    ref={carouselRef}
                >
                    <div
                        className={selectedTag === -1 ? "tag-active" : "tag"}
                        onClick={() => {
                            setSelectedTag(-1);
                            setInputQuery('');
                            setQuery('');
                            setCurrentPage(1);
                            fetchLibraryData('', 1);
                        }}
                        style={{ cursor: "pointer" }}
                    >
                        All
                    </div>
                    {options.map((itm, idx) => (
                        <div
                            key={idx}
                            className={selectedTag === idx ? "tag-active" : "tag"}
                            onClick={() => {
                                setSelectedTag(idx);
                                // setInputQuery(itm);
                                setQuery(itm);
                                setCurrentPage(1);
                                fetchLibraryData(itm, 1);
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            {itm}
                        </div>
                    ))}
                </div>
                <button className="tag-carousel-btn" onClick={handleNext}>&#8250;</button>
            </div>
        );
    };

    const okayErrorFn = () => {
        setErrorMsg(false);
        clearSearch()
    }
    // Handler for Read More click
    const handleReadMore = (item) => {
        setModalContent(item.description);
        setActiveReadMoreModal(true);  // Open the modal
    };

    // Close the modal
    const handleCloseReadMoreModal = () => {
        setActiveReadMoreModal(false);
    };
    // console.log('selecting module', selectedModule)
    const handleModuleClick = (item) => {
        console.log('itemmmmmmmmmm', item)

        if (moduleType === "timedmodule") {
            setSelectedModule(item)
            setShowAccessCodePopup(true)
            return;
        } else {
            console.log("Itemmmmmmmmmmmmmmmmmm", item)
            localStorage.removeItem('usermodule', "usermodule")
            localStorage.setItem('module', "module")
            if (!token) {
                navigate("/login");
                localStorage.setItem("moduleid", item?.moduleid);
                return;
            }
             if (moduleType === "mcqmodule") {

                navigate(`/mcqinstructions/${item?.moduleid}`, {
                    state: { moduleType: "mcqmodule", moduleid: item?.moduleid }
                });
                // navigate(`/moduleslibrary/${item?.moduleid}`);
                return;
            }
            if (item?.subscribed === true) {

                navigate(`/moduleinstructions/${item?.moduleid}`, {
                    state: { moduleType: "allmodules", moduleid: item?.moduleid }
                });
                // navigate(`/moduleslibrary/${item?.moduleid}`);
                return;
            }
            if (item?.cost !== 0 && item?.cost !== "0") {
                setBuyModuleItem(item);
                setShowBuyAlert(true);
                localStorage.setItem("moduleid", item?.moduleid);
            } else {

                navigate(`/moduleslibrary/${item?.moduleid}`);
            }
        }





    };
    // const loadRazorpay = async (buyModuleItem) => {

    //     try {
    //         let id = buyModuleItem?.id;
    //         console.log("Idddddddddddddddddddddd",id)
    //         let amount = Number(buyModuleItem?.cost) * 100;
    //         if (!id) {
    //             let res = await tmdbApi.modulePayments(buyModuleItem?.moduleid);
    //             id = res?.result?.razorpayOrder?.id;
    //             amount = res?.result?.razorpayOrder?.amount;
    //         }
    //         const paymentAmount = amount;
    //         const paymentCurrency = "INR";

    //         // const paymentKey = RAZORPAY_KEY_ID;
    //         const options = {
    //             key: razorpayKey,
    //             amount: paymentAmount,
    //             currency: paymentCurrency,
    //             name: "Dadi",
    //             description: buyModuleItem?.name || "Module Payment",
    //             order_id: id,
    //             handler: async function (response) {
    //                 console.log(response);
    //                 // Handle success/error response here
    //                 let signature = response?.razorpay_signature;
    //                 // Fallback: try to get signature from window or other sources if not present
    //                 if (!signature && window?.razorpay_signature) {
    //                     signature = window.razorpay_signature;
    //                 }
    //                 // Always send signature, even if empty string
    //                 let obj = {
    //                     razorpay_payment_id: response?.razorpay_payment_id || "",
    //                     razorpay_order_id: response?.razorpay_order_id || "",
    //                     razorpay_signature: signature || "",
    //                 };
    //                 // Only treat as success if both payment_id and signature are present
    //                 const isPaymentSuccess = !!(response?.razorpay_payment_id && signature);
    //                 if (isPaymentSuccess) {
    //                     obj.message = "Payment successful";
    //                     let verificationData = await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(obj));
    //                     if (
    //                         response?.razorpay_order_id &&
    //                         verificationData?.result?.gatewayPaymentId &&
    //                         verificationData?.statusCode === 200
    //                     ) {
    //                         navigate(`/moduleslibrary/${buyModuleItem?.moduleid}?buy=1`);
    //                     } else {
    //                         setErrorMsg(true);
    //                         return;
    //                     }
    //                 } else {
    //                     // Add error reason if available
    //                     let reason = response?.error || response?.reason || "Payment failed or was cancelled.";
    //                     let failed = {
    //                         message: `Payment failed: ${reason}`,
    //                     };
    //                     await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(failed));
    //                     setErrorMsg(true);
    //                     return;
    //                 }


    //             },
    //             prefill: {
    //                 name: localStorage.getItem("name") || "User Name",
    //                 email: localStorage.getItem("email") || "",
    //                 contact: localStorage.getItem("contact") || "9999999999",
    //             },
    //             notes: {
    //                 address: localStorage.getItem("email"),
    //             },
    //             theme: {
    //                 color: "#3399cc",
    //             },
    //             modal: {
    //                 ondismiss: async function () {
    //                     // Handle payment modal close/cancel
    //                     let failed = {
    //                         message: `Payment Cancelled`,
    //                     };
    //                     await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(failed));
    //                     setErrorMsg(true);
    //                     return;
    //                 }
    //             }
    //         };
    //         if (window.Razorpay) {
    //             const rzp = new window.Razorpay(options);
    //             rzp.open();
    //         } else {
    //             alert("Razorpay SDK not loaded");
    //         }
    //     } catch (err) {
    //         alert("Failed to initiate payment");
    //         console.error(err);
    //     }
    // };
    // const loadRazorpay = async (buyModuleItem) => {
    //     try {
    //         let id = buyModuleItem?.id;
    //         let amount = Number(buyModuleItem?.cost) * 100;

    //         if (!id) {
    //             let res = await tmdbApi.modulePayments(buyModuleItem?.moduleid);
    //             id = res?.result?.razorpayOrder?.id;
    //             amount = res?.result?.razorpayOrder?.amount;
    //         }

    //         const options = {
    //             key: razorpayKey,
    //             amount,
    //             currency: "INR",
    //             display_currency: "INR",

    //             name: "Dadi",
    //             description: buyModuleItem?.name || "Module Payment",
    //             order_id: id,
    //             handler: async function (response) {
    //                 let signature = response?.razorpay_signature || window?.razorpay_signature || "";

    //                 const isPaymentSuccess = !!(response?.razorpay_payment_id && signature);

    //                 if (isPaymentSuccess) {

    //                     navigate(`/moduleslibrary/${buyModuleItem?.moduleid}?buy=1`);

    //                     //Verify in background
    //                     (async () => {
    //                         let obj = {
    //                             razorpay_payment_id: response?.razorpay_payment_id || "",
    //                             razorpay_order_id: response?.razorpay_order_id || "",
    //                             razorpay_signature: signature || "",
    //                             message: "Payment successful",
    //                         };
    //                         try {
    //                             await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(obj));
    //                         } catch (err) {
    //                             console.error("Background verification failed", err);
    //                         }
    //                     })();
    //                 } else {
    //                     let reason = response?.error || response?.reason || "Payment failed or was cancelled.";
    //                     let failed = { message: `Payment failed: ${reason}` };
    //                     await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(failed));
    //                     setErrorMsg(true);
    //                 }
    //             },
    //             prefill: {
    //                 name: localStorage.getItem("name") || "User Name",
    //                 email: localStorage.getItem("email") || "",
    //                 contact: localStorage.getItem("contact") || "9999999999",
    //             },
    //             notes: {
    //                 address: localStorage.getItem("email"),
    //             },
    //             theme: {
    //                 color: "#3399cc",
    //             },
    //             modal: {
    //                 ondismiss: async function () {
    //                     let failed = { message: `Payment Cancelled` };
    //                     await tmdbApi.verifyPayments(null, buyModuleItem?.moduleid, JSON.stringify(failed));
    //                     setErrorMsg(true);
    //                 }
    //             }
    //         };

    //         if (window.Razorpay) {
    //             const rzp = new window.Razorpay(options);
    //             rzp.open();
    //         } else {
    //             alert("Razorpay SDK not loaded");
    //         }
    //     } catch (err) {
    //         alert("Failed to initiate payment");
    //         console.error(err);
    //     }
    // };

    const loadRazorpay = async (buyModuleItem) => {
        console.group("🧾 Razorpay Payment Flow Started");

        try {
            console.log("1️⃣ Buy module item received:", buyModuleItem);

            let id = buyModuleItem?.id;
            let amount = Number(buyModuleItem?.cost) * 100;

            console.log("2️⃣ Initial values", { id, amount });

            // STEP 1: Create / Fetch Order from Backend
            if (!id) {
                console.log("3️⃣ No order id found, calling backend to create order...");

                let res = await tmdbApi.modulePayments(buyModuleItem?.moduleid);

                console.log("4️⃣ Backend order creation response:", res);

                id = res?.result?.razorpayOrder?.id;
                amount = res?.result?.razorpayOrder?.amount;

                console.log("5️⃣ Order extracted from backend:", { id, amount });

                if (!id) {
                    console.error("❌ Order ID not received from backend");
                    throw new Error("Order creation failed");
                }
            }

            // STEP 2: Razorpay Options
            const options = {
                key: razorpayKey,
                amount,
                currency: "INR",
                display_currency: "INR",
                name: "Dadi",
                description: buyModuleItem?.name || "Module Payment",
                order_id: id,

                handler: async function (response) {
                    console.group("✅ Razorpay Handler Triggered");

                    console.log("6️⃣ Razorpay response:", response);

                    let signature =
                        response?.razorpay_signature ||
                        window?.razorpay_signature ||
                        "";

                    const isPaymentSuccess = !!(
                        response?.razorpay_payment_id && signature
                    );

                    console.log("7️⃣ Payment success status:", isPaymentSuccess);

                    if (isPaymentSuccess) {
                        console.log("8️⃣ Navigating to module library");

                        navigate(`/moduleslibrary/${buyModuleItem?.moduleid}?buy=1`);

                        // Background verification
                        (async () => {
                            let obj = {
                                razorpay_payment_id: response?.razorpay_payment_id || "",
                                razorpay_order_id: response?.razorpay_order_id || "",
                                razorpay_signature: signature || "",
                                message: "Payment successful",
                            };

                            console.log("9️⃣ Sending verification payload to backend:", obj);
                            const razorPayNewOrderId = id

                            try {
                                await tmdbApi.verifyPayments(
                                    null,
                                    buyModuleItem?.moduleid,
                                    JSON.stringify(obj),
                                    razorPayNewOrderId

                                );
                                console.log("🔟 Payment verification success");
                            } catch (err) {
                                console.error("❌ Background verification failed", err);
                            }
                        })();
                    } else {
                        let reason =
                            response?.error ||
                            response?.reason ||
                            "Payment failed or was cancelled.";
                        const razorPayNewOrderId = id
                        console.error("❌ Payment failed:", reason);

                        let failed = { message: `Payment failed: ${reason}` };
                        let status = "FAILED"
                        await tmdbApi.verifyPayments(
                            null,
                            buyModuleItem?.moduleid,
                            JSON.stringify(failed),
                            razorPayNewOrderId, status

                        );
                        setErrorMsg(true);
                    }

                    console.groupEnd();
                },

                prefill: {
                    name: localStorage.getItem("name") || "User Name",
                    email: localStorage.getItem("email") || "",
                    contact: localStorage.getItem("contact") || "9999999999",
                },

                notes: {
                    address: localStorage.getItem("email"),
                },

                theme: {
                    color: "#3399cc",
                },

                modal: {
                    ondismiss: async function () {
                        console.warn("⚠️ Razorpay modal dismissed by user");
                        let status = "CANCELLED"
                        const razorPayNewOrderId = id
                        let failed = { message: "Payment Cancelled" };
                        await tmdbApi.verifyPayments(
                            null,
                            buyModuleItem?.moduleid,
                            JSON.stringify(failed),
                            razorPayNewOrderId, status
                        );
                        setErrorMsg(true);
                    },
                },
            };

            console.log("🧩 Razorpay options prepared:", options);

            // STEP 3: Open Checkout
            if (window.Razorpay) {
                console.log("🚀 Opening Razorpay Checkout");
                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                console.error("❌ Razorpay SDK not loaded");
                alert("Razorpay SDK not loaded");
            }
        } catch (err) {
            console.error("❌ Payment initiation failed:", err);
            alert("Failed to initiate payment");
        } finally {
            console.groupEnd();
        }
    };


    // const handleBuyModule = async () => {
    //     await loadRazorpay(buyModuleItem);
    //     // if (buyModuleItem) {
    //     //     localStorage.setItem("moduleid", buyModuleItem?.moduleid);
    //     //     localStorage.setItem("selectedCost", buyModuleItem?.cost);
    //     //     navigate(`/moduleslibrary/${buyModuleItem?.moduleid}?buy=1`);
    //     // }
    //     setShowBuyAlert(false);
    //     setBuyModuleItem(null);
    // };
    const handleBuyModule = async () => {
        // const token = localStorage.getItem("token");

        console.log('tokennnnnnnnnnnnnnnn', token)

        // If token exists → block the purchase and show error
        if (!token) {
            return {
                error: "Please login to buy module"
            };
        }

        // Continue with buy flow
        await loadRazorpay(buyModuleItem);

        setShowBuyAlert(false);
        setBuyModuleItem(null);
    };

    const handleGoToSubscription = () => {
        if (buyModuleItem) {
            localStorage.setItem("moduleid", buyModuleItem?.moduleid);
            localStorage.setItem("selectedCost", buyModuleItem?.cost);
            navigate("/subscription");
        }
        setShowBuyAlert(false);
        setBuyModuleItem(null);
    };

    const handleHistory = (item) => {
        navigate(`/history/${item?.moduleid}`);
    }
    const handleClosePopup = () => {
        setShowAccessCodePopup(false)
    }
    // console.log('sssssssssssss', razorpayKey, showBuyAlert, buyModuleItem)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            {razorpayKey && showBuyAlert && buyModuleItem && buyModuleItem?.subscribed !== true &&
                (buyModuleItem?.cost !== 0 && buyModuleItem?.cost !== "0" && token) && (
                    <div className="buy-module-alert">
                        <SweetAlert
                            title=""
                            onConfirm={handleBuyModule}
                            onCancel={() => {
                                setShowBuyAlert(false);
                                setBuyModuleItem(null);
                                localStorage.removeItem("moduleid")
                            }}
                            allowOutsideClick={false}
                            closeOnClickOutside={false}
                            closeOnEsc={false}
                            showConfirm={false}
                            showCancel={false}
                            customclassName="buy-module-alert-redesign"
                        >
                            <div className="buy-module-content">
                                {/* Close Button */}
                                <button
                                    className="close-btn"
                                    onClick={() => {
                                        setShowBuyAlert(false);
                                        setBuyModuleItem(null);
                                        localStorage.removeItem("moduleid")
                                    }}
                                >
                                    ×
                                </button>

                                {/* Icon */}
                                <div className="module-icon">
                                    {/* <ShoppingBagIcon sx={{ fontSize: 32, color: '#FF6B35' }} /> */}
                                    <span className="material-symbols-outlined">
                                        shopping_bag
                                    </span>
                                </div>

                                {/* Title */}
                                <h2 className="module-title">Buy Module</h2>

                                {/* Module Name Badge */}
                                <div className="module-name-badge">
                                    {buyModuleItem?.name || "Introduction to Dermatopathology"}
                                </div>

                                {/* Description */}
                                <p className="module-description">
                                    Purchase this specific module for <strong className="txt-in-desc">₹{buyModuleItem?.cost || 10}</strong>.
                                    {/* <br /> */}
                                    {' '}Alternatively, subscribe now to enjoy{' '}
                                    <span className="highlight-text">unlimited access</span> to our entire library of learning materials.
                                </p>

                                {/* Buy Module Button */}
                                <button
                                    className="btn-buy-module"
                                    onClick={handleBuyModule}
                                >
                                    <div className="buy-module-text">
                                        <span className="buy_txt">Buy Module</span>
                                        <span className="one_time_txt">One-time purchase</span>
                                    </div>
                                    <div className="buy-module-price">
                                        <span className="price-tag">₹{buyModuleItem?.cost || 10}</span>
                                        <span className="material-symbols-outlined arrow-icon">
                                            arrow_right_alt
                                        </span>
                                    </div>
                                </button>

                                {/* Subscribe Button */}
                                <button
                                    className="btn-subscribe"
                                    onClick={handleGoToSubscription}
                                >

                                    <div className="subscribe-text">
                                        <span className="subscribe-title">Subscribe Now</span>
                                        <span className="subscribe-subtitle">Unlock all modules</span>
                                    </div>
                                    <span className="material-symbols-outlined star-icon">
                                        star
                                    </span>
                                </button>

                                {/* Cancel Link */}
                                <button
                                    className="btn-cancel-link"
                                    onClick={() => {
                                        setShowBuyAlert(false);
                                        setBuyModuleItem(null);
                                        localStorage.removeItem("moduleid")
                                    }}
                                >
                                    Cancel
                                </button>

                                {/* Footer */}
                                {/* <div className="secure-footer">
                                    <span>Secure payment powered by Dermpath Academy</span>
                                </div> */}
                            </div>
                        </SweetAlert>
                    </div>
                )}
            {/* <Modal
                className="access-code-popup"
                show={showAccessCodePopup}
                onHide={handleClosePopup}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Enter Access Code</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <p className="text-muted mb-3">
                            Please enter the access code to open this module.
                        </p>

                        <div className="form-group">
                            <label className="col-form-label fw-semibold">Access Code</label>
                            <input
                                className="form-control"
                                type="password"
                                name="accessCode"
                                placeholder="Enter access code"
                                onChange={(e) => handleAccessCodeChange(e)}
                                value={accessCode}
                                autoFocus
                            />
                            {errorDisplay && (
                                <span
                                    className="errormsg text-danger fw-bold mt-1 d-block"
                                >
                                    {errorData?.accessCode || "Invalid access code"}
                                </span>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={handleClosePopup}
                    >
                        Cancel
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={(e) => handleAccessCodeSubmit(e)}
                    >
                        Submit
                    </button>
                </Modal.Footer>
            </Modal> */}
            <Modal
                className="access-code-popup"
                show={showAccessCodePopup}
                onHide={handleClosePopup}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{selectedModule?.name}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <p className="text-muted mb-3">
                            Enter the access code to unlock this module.
                        </p>

                        <div className="form-group">
                            <label className="col-form-label fw-semibold">Access Code</label>
                            <input
                                className="form-control"
                                type="text"
                                name="accessCode"
                                placeholder="Enter access code here"
                                onChange={handleAccessCodeChange}
                                value={accessCode}
                                autoFocus
                            />
                            {errorDisplay && (
                                <span className="errormsg text-danger fw-bold mt-1 d-block">
                                    {errorData?.accessCode}
                                </span>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between modal-footer-custom">
                    <button
                        className="btn reset-quiz-btn"
                        onClick={handleClosePopup}
                        disabled={loadingAccess}
                    >
                        Cancel
                    </button>

                    <button
                        className="btn create-quiz-btn"
                        onClick={handleAccessCodeSubmit}
                        disabled={loadingAccess}
                    >
                        {loadingAccess ? "Verifying..." : "Submit"}
                    </button>
                </Modal.Footer>
            </Modal>

            <div className="p-4 video-section-wrapper">
                <div className="row breadcrumb" id="breadcrumb-row">
                    <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                                <h4 className="mb-2 card-title" id="breadcrumb-title">
                                    {moduleType === 'timedmodule' ?'Timed Modules' : moduleType === 'mcqmodule'? 'MCQ Modules' : 'All Modules'}
                                </h4>

                                {/* <p className="menu-path" id="breadcrumb-path"><span>Learning Hub</span> / <b id="breadcrumb-action">Video Library</b></p> */}
                            </div>
                            <div>
                                {!token && (<a id="back-button" className="stroke-btn-style create-quiz-btn" onClick={() => backTpPrev()}>back</a>)}

                            </div>
                        </div>
                    </div>
                </div>
                {/* Tags & Search */}
                {/* { data && data.length > 0 && */}
                <div className="row align-items-center mb-4 video-library">
                    <div className="col-lg-8">
                        <TagCarousel />
                    </div>
                    <div className="col-lg-4 user-management video-search-bar">
                        <div className="table-data">
                            <div className="search-box mb-2 d-inline-block" id="search-box">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search modules..."
                                        value={inputQuery}
                                        onChange={e => setInputQuery(e.target.value)}
                                        id="search-input"
                                    />
                                    <button className="fill_btn" onClick={submitData} id="search-btn">
                                        <span className="material-icons search-icon">search</span>
                                    </button>
                                </div>
                                <div className="dataTables_length" id="datatable-length-reset">
                                    <button className="fill_btn" onClick={clearSearch} id="reset-btn">
                                        <span className="material-icons-outlined">sync</span>Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div><div className="text-sm-end" id="text-end"></div>
                </div>
                {/* } */}

                {/* Video Cards */}
                <div className="mt-3">
                    {isLoading ? <Loader /> :

                        <>


                            <div className="row video-grid">
                                {data && data.length > 0 ? (
                                    data.map((item) => {
                                        const videoId = getYouTubeVideoId(item.youtube);

                                        return (
                                            <div className="col-lg-3 col-md-6 mb-4" key={item._id}>
                                                <a className="text-decoration-none text-dark">
                                                    <div className="video-card"
                                                    >
                                                        {
                                                            img && item?.modulefiles?.length > 0 && item?.modulefiles[0]?.sourcepath
                                                                ? (
                                                                    <img
                                                                        src={`${img}${item.modulefiles[0].sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                        alt=""
                                                                    />
                                                                )
                                                                : (
                                                                    <img src="assets/images/module-default-img.svg" alt="" />
                                                                )
                                                        }


                                                        {(item?.subscribed === true || item?.cost === 0 || item?.cost === "0") && (
                                                            <button
                                                                className="play-btn"
                                                                onClick={() => handleModuleClick(item)}
                                                            >
                                                                <span className="material-symbols-outlined">
                                                                    open_in_new
                                                                </span>
                                                            </button>
                                                        )}



                                                    </div>
                                                    <div>



                                                        <div className="d-flex justify-content-between align-items-center mt-3 module-card">
                                                            <a className="video-title mb-0" onClick={() => handleModuleClick(item)}>{item?.name}</a>
                                                            {item?.subscribed !== true &&
                                                                item?.cost !== 0 &&
                                                                item?.cost !== "0" &&
                                                                (<button className="btn-fill-icon d-flex align-items-center buy-btn" onClick={() => handleModuleClick(item)}>

                                                                    {`₹ ${item?.cost}/-`} </button>)

                                                            }

                                                        </div>

                                                        <p className="video-para mt-2 mb-0">{<div dangerouslySetInnerHTML={{ __html: item?.description }} />
                                                            || "sample module desc"}</p>
                                                        {/* <p className="video-para mt-2 mb-0">{item?.description}</p> */}
                                                        {item?.description?.length > 200 && (
                                                            <div className="video-link mt-0"
                                                                style={{
                                                                    cursor: 'pointer',          // Hand cursor on hover
                                                                    // color: '#007bff',            // Blue text color
                                                                }} onClick={() => handleReadMore(item)}>Read more ...</div>
                                                        )}
                                                        <div className="d-flex justify-content-between">
                                                            <div className="d-flex gap-2 video-stats">
                                                                <span>{item?.time}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        );
                                    })
                                ) : (

                                    <div className="empty-state-body empty-record"  >
                                        <div className="empty-state__message">
                                            <span className="material-icons">summarize</span>
                                            <p className="form-check font-size-16">No Modules Found.</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>

                    }

                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                        <nav>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)} disabled={currentPage === 1}>Prev</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${(currentPage === totalPages || (data && data.length < itemsPerPage)) ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(prev => prev + 1)}
                                        disabled={currentPage === totalPages || (data && data.length < itemsPerPage)}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}

                <Modal
                    className="access-code-popup module-description-modal"
                    show={activeReadMoreModal}
                    // backdrop="static"
                    backdrop="true"
                    centered
                    onHide={handleCloseReadMoreModal}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Module Description</Modal.Title>
                        <span className="material-icons close-icon" onClick={handleCloseReadMoreModal}>close</span>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="access-code-body">
                            <div className="form-group feebback-box">
                                {/* Rendering the rich HTML content inside the modal */}
                                <div className="modal-description"
                                    dangerouslySetInnerHTML={{ __html: modalContent }}  // This renders HTML content
                                />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <ToastContainer
                    id="toastContainer"
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover={false}
                    theme="light"
                />
            </div>
            <SweetAlert
                show={errorMsg}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="payment failed or cancelled"
                onConfirm={() => okayErrorFn()}
                id="error-alert"
            />
        </>
    );
};

export default ML;